import { Navigate } from "react-router-dom";
import { useAdminAuth } from "./auth";

const AdminProtected = ({ children }) => {
  const { user, loading } = useAdminAuth();
  if (loading) {
    return (
      <div className="vd-page flex items-center justify-center" style={{ minHeight: "60vh" }}>
        <p className="vd-muted">Checking session…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

export default AdminProtected;
